import { render, staticRenderFns } from "./commonHearder.vue?vue&type=template&id=0ed5ee3d&scoped=true"
import script from "./commonHearder.vue?vue&type=script&lang=js"
export * from "./commonHearder.vue?vue&type=script&lang=js"
import style0 from "./commonHearder.vue?vue&type=style&index=0&id=0ed5ee3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed5ee3d",
  null
  
)

export default component.exports